import { ApplicationPrefix } from '@openx/constants/paths.ts';

import { getBasenameWithInstanceId } from './getBasenameWithInstanceId.ts';
import { isPathInApp } from './isPathInApp.ts';

export function getAppRootPath(): string {
  const pathname = new URL(window.location.href).pathname;

  // All apps use a slug-aware router basename (see getBasenameWithInstanceId),
  // so the root path must include the instance slug segment to match the current router basename.
  if (isPathInApp(pathname, ApplicationPrefix.Unity)) {
    return getBasenameWithInstanceId(ApplicationPrefix.Unity, pathname);
  } else if (isPathInApp(pathname, ApplicationPrefix.Publisher)) {
    return getBasenameWithInstanceId(ApplicationPrefix.Publisher, pathname);
  } else if (isPathInApp(pathname, ApplicationPrefix.Dsp)) {
    return getBasenameWithInstanceId(ApplicationPrefix.Dsp, pathname);
  } else {
    return '';
  }
}
